// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__GIFyn","modal":"modal_modal__4ixK1","container-btn":"modal_container-btn__gr1TB"};